export default __webpack_public_path__ + "media/images/plans/carry-d9ec3a15337ee2c80d0c73eb92118acd.png";